import algoliasearch from 'algoliasearch';
import { clearAlgoliaKeysAndRefresh } from '../../hooks/useAlgolia';

/** Minimum time between clear+refresh to avoid infinite loop on repeated errors */
const MIN_CLEAR_INTERVAL_MS = 60 * 1000;

let lastClearTime = 0;

const clearKeysIfNotRecent = async () => {
  const now = Date.now();
  if (now - lastClearTime >= MIN_CLEAR_INTERVAL_MS) {
    lastClearTime = now;
    await clearAlgoliaKeysAndRefresh();
  }
};

export const algoliaClient = (appId, apiKey) => {

  return algoliasearch(appId || ' ', apiKey || ' ');
};

export const searchClient = async (searchIndex, searchQuery, searchParams) => {
  if (!searchIndex) return { hits: 0 };
  try {
    const result = await searchIndex.search(searchQuery, searchParams);
    return result;
  } catch (e) {
    await clearKeysIfNotRecent();
    console.error(e);
    return null;
  }
};

export const searchObject = async (index, id) => {
  if (!index) {
    throw new Error('Algolia index is required');
  }
  try {
    const result = await index.getObject(id);
    return result;
  } catch (e) {
    await clearKeysIfNotRecent();
    console.error(e);
    throw e;
  }
};

/**
 * Wrapper for index.searchForFacetValues with error handling.
 * On any error, clears algoliaKeys and fetches new keys (at most once per minute to avoid loops).
 * Returns a safe default when index is missing (e.g. no keys or no sort match) so we do not clear valid keys.
 */
export const searchForFacetValues = async (index, facetName, facetQuery, searchParams) => {
  if (!index) {
    return { facetHits: [] };
  }
  try {
    return await index.searchForFacetValues(facetName, facetQuery, searchParams);
  } catch (e) {
    await clearKeysIfNotRecent();
    console.error(e);
    throw e;
  }
};
